import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import TreatmentList from "./components/Treatment/TreatmentList";

// Pages
import Home from "./Pages/Home";
import AcneTreatment from "./Pages/AcneTreatment";
import TattooRemoval from "./Pages/TattooRemoval";
import HairTreatment from "./Pages/HairTreatment";
import CarbonLaserFacial from "./Pages/CarbonLaserFacial";
import AntiAgeing from "./Pages/AntiAgeing";
import Microneedling from "./Pages/Microneedling";
import NailDiseasesTreatment from "./Pages/NailDiseasesTreatment";
import SkinTagMoleWartRemoval from "./Pages/SkinTagMoleWartRemoval";
import PRPTreatment from "./Pages/PRPTreatment";
import FungalInfection from "./Pages/FungalInfection";
import ChemicalPeeling from "./Pages/ChemicalPeeling";
import LaserHairRemoval from "./Pages/LaserHairRemoval";
import SkinConcerns from "./Pages/SkinConcerns";
import HairConcerns from "./Pages/HairConcerns";

import MedicalProduct from "./Pages/MedicalProduct";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import ContactUs from "./Pages/ContactUs"
import AboutDoctorTrupti from "./Pages/AboutDoctor";
import DoctorProfile from "./Pages/DoctorProfile";
import Doctors from "./Pages/Doctors";

import LoginPage from "./Pages/LoginPage";
import DoctorDashboard from "./Pages/DoctorDashboard";
import AdminDashboard from "./Pages/AdminDashboard";
import AppointmentView from "./Pages/AppointmentView";
import AttendedAppointments from "./Pages/AttendedAppointments";

function App() {
  return (
    <Router>
      <Analytics />
      <SpeedInsights/>
      <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutDoctor" element={<AboutDoctorTrupti/>} />
        <Route path="/products" element={<MedicalProduct/>} />
        <Route path="/ContactUS" element={<ContactUs />} />
        <Route path="/doctor/:id" element={<DoctorProfile />} />
        <Route path="/doctors" element={<Doctors />} />

        {/* Treatments */}
        <Route path="/treatments" element={<TreatmentList />} />
        <Route path="/treatments/acne" element={<AcneTreatment />} />
        <Route path="/treatments/tattoo" element={<TattooRemoval />} />
        <Route path="/treatments/hair" element={<HairTreatment />} />
        <Route path="/treatments/carbonlaser" element={<CarbonLaserFacial />} />
        <Route path="/treatments/antiaging" element={<AntiAgeing />} />
        <Route path="/treatments/microneedling" element={<Microneedling/>} />
        <Route path="/treatments/nail-disease" element={<NailDiseasesTreatment />} />
        <Route path="/treatments/prp" element={<PRPTreatment />} />
        <Route path="/treatments/fungalinfection" element={<FungalInfection />} />
        <Route path="/treatments/chemicalpeel" element={<ChemicalPeeling />} />
        <Route path="/treatments/laserhair" element={<LaserHairRemoval />} />
        <Route path="/treatments/skintag-removal" element={<SkinTagMoleWartRemoval />} />

        <Route path="/skin-concerns" element={<SkinConcerns />} />
        <Route path="/hair-concerns" element={<HairConcerns />} /> 

        <Route path="/login" element={<LoginPage/>} /> 
        <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/appointment/:id" element={<AppointmentView />} />
        <Route path="/attended" element={<AttendedAppointments />} />

      </Routes>
    </Router>
  );
}

export default App;
